export default __webpack_public_path__ + "images/1792455530607578f1b24de86787f0a4-Eventbrite_Holiday_HomepageB_1920x544.webp";